import styles from "./GridLines.module.scss";

type GridLinesProps = {
  linePositions: number[];
  chartWidth: number;
  strokeWidth: number;
};

const GridLines = ({
  linePositions,
  chartWidth,
  strokeWidth
}: GridLinesProps) => (
  <g pointerEvents="none">
    {linePositions.map((lineY) => (
      <line
        key={`grid-line-${lineY}`}
        className={styles.gridLine}
        x1={0}
        y1={lineY}
        x2={chartWidth}
        y2={lineY}
        strokeWidth={strokeWidth}
      />
    ))}
  </g>
);

export default GridLines;
